export default __webpack_public_path__ + "static/media/pricing-05-image-03.9fbc7290.png";